/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { User } from './User';
// @ts-ignore
import {
// @ts-ignore
    UserFromJSON,
// @ts-ignore
    UserFromJSONTyped,
// @ts-ignore
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface UserListResponse
 */
export interface UserListResponse {
    /**
     * 
     * @type {number}
     * @memberof UserListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UserListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<User>}
     * @memberof UserListResponse
     */
    items: Array<User>;
}

/**
 * Check if a given object implements the UserListResponse interface.
 */
// @ts-ignore
export function instanceOfUserListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function UserListResponseFromJSON(json: any): UserListResponse {
    return UserListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function UserListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(UserFromJSON)),
    };
}

// @ts-ignore
export function UserListResponseToJSON(value?: UserListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(UserToJSON)),
    };
}

